import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { addDays, format, parse } from 'date-fns';
import { useMemo, useState } from 'react';
import { MyIbeCalenderView } from './MyIbeCalenderView';
import { MyIbePropertyView } from './MyIbePropertyView';
export const MyIbeAvailabilityCalendar = (props) => {
    const { availabilities, variant, translation, property, imageBaseUrl } = props;
    const { onChange } = props;
    const [state, setState] = useState({ checkIn: null, checkOut: null });
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    const [hoveringDay, setHoveringDay] = useState(null);
    const { checkIn, checkOut } = state;
    const changeState = (checkIn, checkOut) => {
        setState({ checkIn, checkOut });
        onChange(checkIn, checkOut);
    };
    const onDayClick = (day) => {
        const checkInSelected = (checkIn !== null);
        const beforeCheckIn = checkInSelected && (day.date < checkIn);
        const checkOutSelected = (checkOut !== null);
        if (checkInSelected && (day.date === checkIn)) {
            changeState(null, null);
            setMinDate(null);
            setMaxDate(null);
        }
        else if (!checkInSelected || checkOutSelected || beforeCheckIn) {
            changeState(day.date, null);
            if (day.restrictions.minLengthOfStay > 0) {
                const dayDate = parse(day.date, 'yyyy-MM-dd', 0);
                const minDate = format(addDays(dayDate, day.restrictions.minLengthOfStay), 'yyyy-MM-dd');
                setMinDate(minDate);
            }
            else {
                setMinDate(null);
            }
            if (day.restrictions.maxLengthOfStay > 0) {
                const dayDate = parse(day.date, 'yyyy-MM-dd', 0);
                const maxDate = format(addDays(dayDate, day.restrictions.maxLengthOfStay), 'yyyy-MM-dd');
                setMaxDate(maxDate);
            }
            else {
                setMaxDate(null);
            }
        }
        else {
            changeState(checkIn, day.date);
        }
    };
    const onDayHover = (day, hovering) => {
        if (hovering) {
            setHoveringDay(day);
        }
        else if (hoveringDay && (hoveringDay === day)) {
            setHoveringDay(null);
        }
    };
    const dates = useMemo(() => availabilities.sort((a, b) => {
        return (a.date > b.date) ? 1 : (a.date < b.date) ? -1 : 0;
    }), [availabilities]);
    // true if min one where departure is allowed
    function isDeparturePossible(maxStayDays) {
        if ((maxStayDays.length > 0)
            && !(maxStayDays[0].restrictions.closedOnDeparture && maxStayDays[0].restrictions.closed)) {
            const departureDay = maxStayDays.find((stayDay) => {
                const departureAllowed = !stayDay.restrictions.closedOnDeparture;
                const mustLeave = stayDay.restrictions.closed || !stayDay.isAvailable;
                return departureAllowed || mustLeave;
            });
            return (departureDay !== undefined) && !departureDay.restrictions.closedOnDeparture;
        }
        return false;
    }
    const weeks = useMemo(() => {
        // TODO dates.length is not correct - but we do not have more data (expensive api calls)
        const maxDays = dates.length;
        const result = {};
        let endFound = false;
        let lastDay = null;
        dates.forEach((day, index) => {
            if (!result[day.week]) {
                result[day.week] = { 1: null, 2: null, 3: null, 4: null, 5: null, 6: null, 7: null };
            }
            result[day.week][day.weekday] = day;
            day.allowArrival = false;
            if (day.isAvailable && !day.restrictions.closed && !day.restrictions.closedOnArrival) {
                const minStay = (day.restrictions.minLengthOfStay > 1) ? day.restrictions.minLengthOfStay : 1;
                const maxStay = (day.restrictions.maxLengthOfStay > 0) ? day.restrictions.maxLengthOfStay : maxDays;
                const minStayDays = dates.slice(index, index + minStay - 1);
                const maxStayDays = dates.slice(index + minStay - 1, index + maxStay);
                // all minStay Days must be available == there is no closed day
                const minStayAvailable = !minStayDays.find(stayDay => (stayDay.restrictions.closed || !stayDay.isAvailable));
                day.allowArrival = minStayAvailable && isDeparturePossible(maxStayDays);
            }
            day.allowDeparture = !endFound
                && (minDate === null || minDate <= day.date)
                && (maxDate === null || maxDate >= day.date)
                && (lastDay === null || lastDay.isAvailable);
            if (day.date === '2023-03-24') {
                console.log(day.date, {
                    maxDate,
                    endFound,
                    lastDay: lastDay,
                });
            }
            if ((checkIn !== null) && (checkIn < day.date) && !endFound && !day.isAvailable) {
                console.log(day);
                endFound = true;
            }
            lastDay = day;
        });
        return result;
    }, [dates, checkIn, checkOut]);
    const rules = (day) => {
        if (day) {
            //enabled == can be selected
            let enabled;
            // start date not yet selected => enable only valid days for arrival
            if (checkIn === null) {
                enabled = day.allowArrival;
            }
            else if (checkOut === null) {
                // end date not selected => enable only valid checkout days
                enabled = ((day.date === checkIn)
                    || ((day.date > checkIn)
                        && !day.restrictions.closedOnDeparture
                        && day.allowDeparture
                        && ((maxDate === null) || (day.date <= maxDate))));
            }
            else {
                enabled = (day.date >= checkIn) && (day.date <= checkOut);
            }
            const selected = (checkIn !== null) && (day.date >= checkIn)
                && (
                // must select for min stay
                (minDate !== null && day.date < minDate)
                    // selected
                    || (checkOut !== null) && (day.date <= checkOut));
            const preview = (hoveringDay !== null)
                && (checkIn !== null)
                && (hoveringDay !== day)
                && (day.date > checkIn)
                && (day.date < hoveringDay.date)
                && rules(hoveringDay).enabled;
            const afterCheckIn = (checkIn !== null)
                && (day.date !== checkIn)
                && (day.date > checkIn);
            const isCheckIn = (checkIn !== null) && (checkIn === day.date);
            const isCheckOut = (checkOut !== null) && (checkOut === day.date);
            return { enabled, selected, preview, afterCheckIn, isCheckIn, isCheckOut };
        }
        else {
            return {
                enabled: false,
                selected: false,
                preview: false,
                afterCheckIn: false,
                isCheckIn: false,
                isCheckOut: false,
            };
        }
    };
    return (_jsx(_Fragment, { children: (variant === 'property')
            ? _jsx(MyIbePropertyView, { property: property, days: dates, dayOptions: rules, translation: translation, onDayClick: onDayClick, onDayHover: onDayHover, imageBaseUrl: imageBaseUrl })
            : _jsx(MyIbeCalenderView, { month: weeks, dayOptions: rules, translation: translation, onDayClick: onDayClick, onDayHover: onDayHover }) }));
};
//# sourceMappingURL=MyIbeAvailabilityCalendar.js.map